// https://github.com/nuxt/nuxt/issues/14766
const assets = import.meta.glob<any>('~/assets/{icons,images}/**/*', {
  import: 'default',
})

export function useAsset(path: ComputedRef<string>): any {
  return computed(() => {
    const assetPath = `/assets/${path.value}`
    const importFn = assets[assetPath]

    if (!importFn) {
      return null
    }

    return path.value.endsWith('.svg') ? defineAsyncComponent(() => dynamicImport(importFn, assetPath)) : () => dynamicImport(importFn, assetPath)
  })
}
